import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid } from 'react-bootstrap';

import { ReactComponent as AppIconRejected } from '../icons/2fa-app-rejected.svg';
import Loader from '../../../../components/Loaders/Loader';

import { authUpdate2faCode } from '../../../../services/endpoints/auth';
import { userLogoutCredentialsAction } from '../../../../redux/actions/user';
import { getErrorMessage } from '../../../../utils/helper';

const Page2FaAppRejected = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [isDisabledCode, setIsDisabledCode] = useState(true);

  const onUpdate2FACode = async (mode) => {
    setIsLoading(true);
    try {
      const response = await authUpdate2faCode({ mode });
      switch (mode) {
      case 'app':
        if (response.data?.code) {
          localStorage.setItem('2fa_code_time', Date.now());
          localStorage.setItem('2fa_code', response.data?.code);
          window.appConfig.second_factor.code = response.data?.code;
          history.replace({ pathname: '/2fa/app', search: history.location.search });
        } else {
          dispatch(userLogoutCredentialsAction('Code is empty'));
          history.replace({ pathname: '/', search: history.location.search });
        }
        break;

      case 'email':
        if (response.data) {
          history.replace({ pathname: '/2fa', search: history.location.search });
        } else {
          dispatch(userLogoutCredentialsAction('Code is empty'));
          history.replace({ pathname: '/', search: history.location.search });
        }
        break;

      default:
        break;
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      localStorage.removeItem('2fa_code_time');
      localStorage.removeItem('2fa_code');
      dispatch(userLogoutCredentialsAction(errorMessage));
    }
  };

  const sendNewCode = (e) => {
    e.preventDefault();
    if (isDisabledCode) return;
    onUpdate2FACode('app');
  };

  const redirectToEmail = async (e) => {
    e.preventDefault();
    onUpdate2FACode('email');
  };

  const checkInit = () => {
    if (window.appConfig?.second_factor?.mode !== 'app' || !location.state?.fromApp) {
      history.replace({
        pathname: '/',
        search: history.location.search,
      });
    }

    if (localStorage?.getItem('2fa_code_time')) {
      const diff = Date.now() - localStorage?.getItem('2fa_code_time');
      if (diff > 15000) {
        setIsDisabledCode(false);
      } else {
        setTimeout(() => setIsDisabledCode(false), diff);
      }
    } else {
      setIsDisabledCode(false);
    }
  };

  useEffect(() => {
    checkInit();
    document.title = '2FA with App';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid bsClass="container">
      <div className="page-2fa page-2fa__app page-2fa__app-rejected">
        {isLoading ? <Loader /> : null}
        <div className="page-2fa__app-container">
          <div>
            <AppIconRejected />
          </div>
          <div className="title">Sign-in rejected</div>
          <div className="mb-24">
            The code you entered is incorrect or has expired.
            <br />
            Please try again, or sign in with your email.
          </div>
          <div className="mb-24">
            <a
              href="# "
              disabled={isDisabledCode}
              onClick={(e) => sendNewCode(e)}
              className={`text-decoration-none${isDisabledCode ? ' disabled' : ''}`}
            >
              Send new code
            </a>
          </div>
          <div>
            <a href="# " onClick={(e) => redirectToEmail(e)} className="text-decoration-none">
              Sign in with email
            </a>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default Page2FaAppRejected;
